import {Button, Flex} from '@chakra-ui/react';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

interface Props {
  onChange: any;
}

export const Zoom: FC<Props> = ({onChange}) => {
  return (
    <Flex
      flexDirection="column"
      w="45px"
      h="98px"
      bg="white"
      boxShadow="0px 0px 10px rgba(151, 151, 151, 0.4)"
      borderRadius="16px"
    >
      <Button
        onClick={() => onChange((zoom: number) => zoom + 1)}
        h="50%"
        bg="white"
        p="0"
        _hover={{bg: 'white'}}
        _focus={{border: 'none'}}
      >
        <ImageUI src="/icons/plus.svg" alt="Plus" />
      </Button>
      <Button
        onClick={() => onChange((zoom: number) => zoom - 1)}
        h="50%"
        bg="white"
        p="0"
        _hover={{bg: 'white'}}
        _focus={{border: 'none'}}
      >
        <ImageUI src="/icons/minus.svg" alt="Minus" />
      </Button>
    </Flex>
  );
};
